module.exports = __webpack_public_path__ + "img/spark-22.7fdf9598.png";